import {
    CreateDimensionInput,
    DimensionType,
    MeasurementUnit,
    UpdateDimensionInput
} from "../../../../API";

import { useIssues } from "../../contexts/IssuesContextProvider";

export const useSubmitDimensions = () => {
    const { parentIdToDimensionMap, onCreateDimension, onEditDimensionSubmit, issueIdToIssueMap } = useIssues();
    const submitDimensions = onCreateDimension && onEditDimensionSubmit ? async (issueId: string, formData: FormData) => {

        const issue = issueIdToIssueMap.get(issueId);
        if (!issue) return;

        const existingDimension = parentIdToDimensionMap.get(issueId);
        const issueLength = parseFloat(formData.get("length") as string || "0");
        const issueWidth = parseFloat(formData.get("width") as string || "0");
        const issueUnit = (formData.get("unit") as MeasurementUnit) || MeasurementUnit.METER;

        const dimensionType = issueLength > 0 && issueWidth > 0 ? DimensionType.SQUARE : DimensionType.LINEAR;

        // if create new
        if (!existingDimension) {
            const dimension: CreateDimensionInput = {
                propertyId: issue.propertyId,
                parentId: issue.id,
                measurement: {
                    length: issueLength,
                    width: issueWidth,
                    measurementUnit: issueUnit,
                    dimensionType: dimensionType,
                },
            };
            await onCreateDimension(dimension);
            return;
        }

        // if update but no values changed
        if (
            existingDimension.measurement?.length === issueLength &&
            existingDimension.measurement?.width === issueWidth &&
            existingDimension.measurement?.measurementUnit === issueUnit
        ) {
            return;
        }

        // update dimension
        const updatedDimension: UpdateDimensionInput = {
            ...existingDimension,
            measurement: {
                length: issueLength,
                width: issueWidth,
                measurementUnit: issueUnit,
                dimensionType: dimensionType
            },
        };
        await onEditDimensionSubmit(updatedDimension);
    } : undefined;

    return { submitDimensions };
};
